import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BannerApp from './BannerApp';
import AdminPanel from './AdminPanel';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BannerApp />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}
